module.exports = __webpack_public_path__ + "media/images/components/c07-helpline-info/helpline-9f06743429b23abab075a026c19f358f.svg";